export enum LogoutReason {
  INACTIVITY_TIMEOUT = 'INACTIVITY_TIMEOUT',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  OTHER = 'OTHER',
}

export enum ErrorCode {
  IP_BLOCKED = 'IP_BLOCKED',
}
